// deps
import { useEffect, useState } from "react";

// internal-deps
import { IWidget } from "@swiggy-private/checkout-core";
import { isEmpty } from "@swiggy-private/js-utils";

interface IUseSpecialRequestParams {
    widgetData?: IWidget;
    onClick: () => void;
    onImpression: () => void;
    onClickSubmit: (instruction: string) => void;
    onClickDelete: () => void;
    onSubmit: (instruction: string) => void;
    onClearCart: () => void;
}

export const useSpecialRequest = ({
    widgetData,
    onClick,
    onImpression,
    onClickSubmit,
    onClickDelete,
    onSubmit,
    onClearCart,
}: IUseSpecialRequestParams) => {
    const [showSheet, setShowSheet] = useState(false);
    const [instruction, setInstruction] = useState("");
    const [draft, setDraft] = useState("");
    const specialRequestInfo = widgetData?.widgetInfo?.specialRequestInfo;

    useEffect(() => {
        if (!isEmpty(specialRequestInfo?.instruction)) {
            setInstruction(specialRequestInfo?.instruction ?? "");
        }
        if (isEmpty(specialRequestInfo)) {
            setShowSheet(false);
        }
    }, [specialRequestInfo]);

    const handleOpenSheet = () => {
        onClick();
        onImpression();
        setDraft(instruction);
        setShowSheet(true);
    };

    const handleCloseSheet = () => {
        setShowSheet(false);
    };

    const handleSubmit = () => {
        setInstruction(draft);
        setShowSheet(false);
        onSubmit(draft);
        onClickSubmit(draft);
    };

    const handleClear = () => {
        setInstruction("");
        onClearCart();
        onClickDelete();
    };

    const handleRightElementClick = () => {
        if (!isEmpty(instruction)) {
            handleClear();
        } else {
            handleOpenSheet();
        }
    };

    return {
        specialRequestInfo,
        instruction,
        draft,
        setDraft,
        showSheet,
        handleOpenSheet,
        handleCloseSheet,
        handleSubmit,
        handleClear,
        handleRightElementClick,
    };
};

export default useSpecialRequest;
